import React from 'react';

class WizardItemTextInputMultiLine extends React.Component {

	constructor(props) {

		super(props);
		this.state = {
			value: ""
		};

		this.onChange = this.onChange.bind(this)
	}

	onChange(e) {
		let trimmedString = e.target.value.substring(0, this.props.data.MaximumNumberOfCharacters);
		this.setState({ value: trimmedString });
		this.props.submitAnswer(trimmedString);
	}

	render() {
		return (
			<div className="wizard-item wizard-item__fake-result wizard-item__multi-line scform">
				<textarea placeholder={this.props.data.PlaceholderText} value={this.state.value} name="" id="" cols="30" onChange={this.onChange} rows="8" data-trackingid={this.props.data.QuestionTrackingId} />
			</div>
		)
	}
}

export default WizardItemTextInputMultiLine;